import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { readAuthToken } from '@noor/api';
import { env } from '@noor/config';
import { merchantQueries } from '@/entities/merchant';
import { MerchantDetailPage } from '@/pages/merchant-detail';

/** Merchant detail route — profile PATCH, verticals PUT, staff. */
export const Route = createFileRoute('/merchants/$merchantId')({
  beforeLoad: () => {
    if (!env.VITE_ENABLE_MSW && !readAuthToken()) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login' });
    }
  },
  loader: ({ context, params }) => {
    // Non-blocking prefetch — render the shell immediately; the page's hooks
    // surface loading/error.
    void context.queryClient
      .prefetchQuery(merchantQueries.detail(params.merchantId))
      .catch(() => undefined);
  },
  component: MerchantDetailRoute,
});

function MerchantDetailRoute() {
  const { merchantId } = Route.useParams();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <MerchantDetailPage
      merchantId={merchantId}
      onBack={() => void navigate({ to: '/merchants', search: {} })}
    />
  );
}
